import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PortalConteosComponent } from './portal-conteos.component';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseSidebarModule } from '@fuse/components';
import { FlexLayoutModule } from '@angular/flex-layout';
import {MatDividerModule} from '@angular/material/divider';
import { TranslateModule } from '@ngx-translate/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';

import {MatSelectModule} from '@angular/material/select';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { ChartsModule } from 'ng2-charts';
import {MatTableModule} from '@angular/material/table';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatSortModule} from '@angular/material/sort';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatMenuModule} from '@angular/material/menu';
import {MatTabsModule} from '@angular/material/tabs';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { DatePipe } from '@angular/common';

const rutas: Routes = [
    {
        path     : 'counting/:id',
        component: PortalConteosComponent,

    },
    {
        path     : 'counting/:id/:lang',
        component: PortalConteosComponent,

    },
];

@NgModule({
  declarations: [PortalConteosComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(rutas),
    FuseSharedModule,
    FuseSidebarModule,
    FlexLayoutModule,
    MatDividerModule,
    TranslateModule,
    MatFormFieldModule,
    MatIconModule,
    MatButtonModule,
    MatProgressBarModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    ChartsModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatTooltipModule,
    MatMenuModule,
    MatTabsModule,
    MatCheckboxModule,
  ],providers: [DatePipe],
})
export class PortalConteosModule { }
